import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-3f837ede"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "vab-footer"
};

const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Copyright ");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_vab_icon = _resolveComponent("vab-icon");

  return _openBlock(), _createElementBlock("footer", _hoisted_1, [_hoisted_2, _createVNode(_component_vab_icon, {
    icon: "copyright-line"
  }), _createTextVNode(" " + _toDisplayString($setup.fullYear) + " " + _toDisplayString($setup.title), 1
  /* TEXT */
  )]);
}